export const errors = {
  NETWORK_ERROR: {
    title: 'Error de Conexión',
    description: 'Por favor, verifica tu conexión a internet.',
    buttonLabel: 'Reintentar',
  },
  SERVER_ERROR: {
    title: 'Algo Salió Mal',
    description: 'Por favor, inténtalo de nuevo más tarde.',
    buttonLabel: 'Reintentar',
  },
  TIMEOUT: {
    title: 'Tiempo de Espera Agotado',
    description: 'La solicitud tardó demasiado.',
    buttonLabel: 'Reintentar',
  },
  SERVICE_UNAVAILABLE: {
    title: 'Servicio No Disponible',
    description: 'El servicio no está disponible temporalmente.',
    buttonLabel: 'Reintentar',
  },
  UNAUTHORIZED: {
    title: 'Sesión Expirada',
    description: 'Por favor, inicia sesión de nuevo.',
  },
  SESSION_EXPIRED: {
    title: 'Sesión Expirada',
    description: 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.',
  },
  INVALID_CREDENTIALS: {
    title: 'Credenciales Inválidas',
    description: 'Las credenciales ingresadas son incorrectas.',
  },
  VALIDATION_ERROR: {
    title: 'Error de Validación',
    description: 'Por favor, revisa tu información e inténtalo de nuevo.',
  },
  NOT_FOUND: {
    title: 'No Encontrado',
    description: 'El recurso solicitado no fue encontrado.',
  },
  INCORRECT_CODE: {
    title: 'Código Incorrecto',
    description: 'El código ingresado es incorrecto. Por favor, inténtalo de nuevo.',
  },
  EXPIRED_CODE: {
    title: 'Código Expirado',
    description: 'El código ha expirado. Por favor, solicita uno nuevo.',
  },
  RESTART_FLOW: {
    title: 'Por Favor Inténtalo de Nuevo',
    description: 'Algo salió mal. Por favor, comienza de nuevo.',
  },
  UNKNOWN: {
    title: 'Error',
    description: 'Ocurrió un error inesperado.',
    buttonLabel: 'Reintentar',
  },
  SMS_UNSUBSCRIBED: {
    title: 'No pudimos enviar el código a {{phoneNumber}}',
    description:
      'Parece que los mensajes a este teléfono están bloqueados. Por favor, actualiza tu número para continuar.',
    buttonLabel: 'Actualizar Número',
  },
  SMS_INVALID_NUMBER: {
    title: 'Número de Teléfono Inválido',
    description: 'El número de teléfono proporcionado no es válido. Por favor, verifica e inténtalo de nuevo.',
  },
  INVALID_PHONE: {
    title: 'Número de Teléfono Inválido',
    description: 'Por favor, ingresa un número de teléfono válido.',
  },
  PHONE_ALREADY_IN_USE: {
    title: 'Teléfono Ya en Uso',
    description: 'Este número de teléfono ya está asociado con otra cuenta.',
  },
  EMAIL_ALREADY_IN_USE: {
    title: 'Correo Electrónico Ya en Uso',
    description: 'Este correo electrónico ya está asociado con otra cuenta.',
  },
  SMS_UNREACHABLE: {
    title: 'No pudimos contactar este número',
    description: 'Por favor, intenta con un número de teléfono diferente.',
  },
  INVALID_ADDRESS: {
    title: 'Dirección Inválida',
    description:
      'La dirección proporcionada no es válida para la entrega de medicamentos. Por favor, actualiza tu dirección.',
    buttonLabel: 'Actualizar Dirección',
  },
  PO_BOX_FOUND: {
    title: 'No Se Aceptan Apartados Postales',
    description: 'No podemos entregar medicamentos a apartados postales. Por favor, usa una dirección física.',
    buttonLabel: 'Actualizar Dirección',
  },
  SHIPPING_ADDRESS_LOAD_FAILED: {
    title: 'No se pudo cargar la dirección',
    description: 'Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  PHARMACY_LOAD_FAILED: {
    title: 'No se pudo cargar la farmacia',
    description: 'Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  SCHEDULING: {
    failedToLoad: 'Error al cargar la información de la visita',
    activeVisitExists: 'Ya tienes una visita activa programada.',
    failedToSchedule: 'Error al programar la visita',
  },
  INVALID_LINK: {
    title: 'Enlace Inválido',
    description: 'Por favor, cierra esta página e inténtalo de nuevo.',
  },
  INSURANCE_ADD_FAILED: {
    title: 'No se Pudo Agregar el Seguro',
    description: 'No pudimos agregar tu seguro. Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  INSURANCE_UPDATE_FAILED: {
    title: 'No se Pudo Actualizar el Seguro',
    description: 'No pudimos actualizar tu seguro. Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  INSURANCE_REMOVE_FAILED: {
    title: 'No se Pudo Eliminar el Seguro',
    description: 'No pudimos eliminar tu seguro. Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  INSURANCE_OCR_FAILED: {
    title: 'No se Pudo Escanear la Tarjeta',
    description:
      'No pudimos leer tu tarjeta de seguro. Por favor, inténtalo de nuevo o ingresa tu información manualmente.',
    buttonLabel: 'Reintentar',
  },
};
